import { Notification } from '@arco-design/web-vue';
import prettyBytes from 'pretty-bytes';

export function checkFileSize(file: File, maxFileSize: number) {
  if (file.size > maxFileSize) {
    Notification.error({
      content: `文件太大，请选择小于 ${prettyBytes(maxFileSize)} 的文件`,
      duration: 10 * 1000,
    });

    return false;
  }

  return true;
}
